import { PrimaryButton } from "./PrimaryButton"

export function ButtonLink({
  href,
  children,
}: {
  href: string
  children: React.ReactNode
}) {
  return <PrimaryButton href={href}>{children}</PrimaryButton>
}
